import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { IAppointment } from '../../interfaces/appointment.interface';
import {
  ClearAppointmentWizardSummary,
  SetAppointmentWizardSelections,
  SetAppointmentWizardSummary,
} from './appointment-wizard.actions';
import { AppointmentWizardSelections, AppointmentWizardStateModel } from './appointment-wizard.models';

const APPOINTMENT_WIZARD_STATE_TOKEN = new StateToken<AppointmentWizardStateModel>('appointmentWizard');

const defaultAppointmentWizardState = {
  summary: null,
  bookableService: null,
  bookableResource: null,
  partner: null,
  staff: null,
  startDate: null,
  startTime: null,
  duration: null,
} as AppointmentWizardStateModel;

@State<AppointmentWizardStateModel>({
  name: APPOINTMENT_WIZARD_STATE_TOKEN,
  defaults: defaultAppointmentWizardState,
})
@Injectable()
export class AppointmentWizardState {
  @Selector()
  static currentSummary(state: AppointmentWizardStateModel): IAppointment | null {
    return state.summary;
  }

  @Selector()
  static currentSelections(state: AppointmentWizardStateModel): AppointmentWizardSelections {
    return {
      bookableService: state.bookableService,
      bookableResource: state.bookableResource,
      partner: state.partner,
      staff: state.staff,
      startDate: state.startDate,
      startTime: state.startTime,
      endDateTime: state.endDateTime,
      duration: state.duration,
    };
  }

  @Action(SetAppointmentWizardSummary)
  setSummary(ctx: StateContext<AppointmentWizardStateModel>, action: SetAppointmentWizardSummary) {
    ctx.patchState({
      summary: action.summary,
    });
  }

  @Action(SetAppointmentWizardSelections)
  setSelections(ctx: StateContext<AppointmentWizardStateModel>, action: SetAppointmentWizardSelections) {
    ctx.patchState({
      ...action.selections,
    });
  }

  @Action(ClearAppointmentWizardSummary)
  clearSummary(ctx: StateContext<AppointmentWizardStateModel>) {
    ctx.setState({
      summary: null,
      bookableService: null,
      bookableResource: null,
      partner: null,
      staff: null,
      startDate: null,
      startTime: null,
      endDateTime: null,
      duration: null,
    });
  }
}
